'use client';

import type { DividerBlock } from '@impact/types';

interface Props {
  block: DividerBlock;
  editing?: boolean;
}

/**
 * Gradient fade variant: a horizontal gradient line that fades to transparent at both edges
 */
export function DividerGradientFade({ block: _block, editing: _editing }: Props) {
  return (
    <div
      className="my-12 h-px w-full"
      style={{
        background:
          'linear-gradient(to right, transparent, hsl(var(--border)) 20%, hsl(var(--border)) 80%, transparent)',
      }}
      aria-hidden="true"
    />
  );
}
